import React from "react";

import { Container} from "react-bootstrap";

const logoSrc = "/logo2.png";
function Footer() {
  return (
    <footer className="py-4">
        <Container className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <img src={logoSrc} alt="Innoish" className="logo-img-sm" />
            <div>
              <div className="fw-bold">Innoish Technologies</div>
              <div className="text-muted small">© {new Date().getFullYear()} Innoish Technologies • All rights reserved</div>
            </div>
          </div>

          <div className="d-flex gap-3">
            <a href="#" className="text-muted small">Privacy</a>
            <a href="#" className="text-muted small">Terms</a>
            <a href="#contact" className="text-muted small">Contact</a>
          </div>
        </Container>
      </footer>
  );
}

export default Footer;
